import classnames from 'classnames';
import React, { ReactNode } from 'react';

import styles from './TextSection.module.scss';

export interface TextSectionProps {
  title: string;
  variant: 'primary' | 'secondary';
  useBulletPoints: boolean;
  textContent: ReactNode[];
}

export const TextSection = ({
  title,
  variant,
  useBulletPoints,
  textContent,
}: TextSectionProps) => {
  if (textContent.length === 0) {
    return null;
  }

  const titleClass =
    variant === 'primary'
      ? styles.titleLabelPrimary
      : styles.titleLabelSecondary;

  return (
    <div className={classnames(styles.root, styles[variant])}>
      <div className={titleClass}>{title}</div>
      <div className={styles.textContentWrapper}>
        {textContent.map((text, index) => (
          <div className={styles.textWrapper} key={index}>
            {useBulletPoints && <div className={styles.bulletItem} />}
            <div>{text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
